import { CommandPage } from "@/lib/command"

import type { EmailComposeSubmitPayload } from "@/components/email/email-compose-panel"

import type {
  OfficeExchangeResponse,
  OfficeStartExtensionCallResponse,
  OfficeTransferDestination,
  OfficeTransferResponse,
  OfficeTransferSource,
} from "./types"

export const OFFICE_EXCHANGE_COMMAND_PATH = "/app/crm/base/cmd/calls/office"

const page = () => CommandPage(OFFICE_EXCHANGE_COMMAND_PATH)

export async function loadOfficeExchange(): Promise<OfficeExchangeResponse> {
  const result = await page().load()
  const data = result.unwrap() as OfficeExchangeResponse
  return {
    configured: data.configured ?? false,
    users: data.users ?? [],
    ring_groups: data.ring_groups ?? [],
    call_queues: data.call_queues ?? [],
    parked_calls: data.parked_calls ?? [],
    queued_calls: data.queued_calls ?? [],
    realtime_cursor: data.realtime_cursor ?? null,
    realtime_state: data.realtime_state ?? "unavailable",
  }
}

export async function transferOfficeCall(args: {
  source: OfficeTransferSource
  destination: OfficeTransferDestination
}): Promise<OfficeTransferResponse> {
  const result = await page().transferCall({
    source: args.source,
    destination: args.destination,
  })
  return result.unwrap() as OfficeTransferResponse
}

export async function startOfficeExtensionCall(
  targetUserId: string
): Promise<OfficeStartExtensionCallResponse> {
  const result = await page().startExtensionCall({ target_user_id: targetUserId })
  return result.unwrap() as OfficeStartExtensionCallResponse
}

export async function sendOfficeUserEmail(payload: EmailComposeSubmitPayload): Promise<void> {
  const result = await page().sendUserEmail({
    from_address: payload.from_address,
    to_addresses: payload.to_addresses,
    cc_addresses: payload.cc_addresses,
    bcc_addresses: payload.bcc_addresses,
    reply_to: payload.reply_to,
    subject: payload.subject,
    body_html: payload.body_html,
    attachments: payload.attachments,
  })
  result.unwrap()
}
